// client/src/components/pages/LexiStar/Replay/transportStyles.ts
//
// The replay's transport buttons (ST-00243), shared by the single-truck page (./Replay) and the
// multi-truck view (./ReplayMulti, ST-00277). The secondary and primary looks are separate class
// sets: mixing `bg-surface` with `bg-primary-500` on one element let the surface win in the
// stylesheet, which left a white icon on a white play button. Primary: primary-700 with
// `text-surface` ink — white on dark teal in light, the dark surface on light teal in dark
// (≥ 4.5:1 in both).

const transportBase =
  'inline-flex items-center justify-center h-10 rounded-lg border transition-colors disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-surface';

export const transportButton = `${transportBase} w-10 border-slate-300 bg-surface text-slate-700 hover:bg-slate-100 hover:text-slate-900`;
export const playButton = `${transportBase} w-12 border-primary-700 bg-primary-700 text-surface shadow-sm hover:bg-primary-800 hover:border-primary-800`;
